import { BrowserRouter } from 'react-router-dom';
import { AppProvider } from '@/context/AppContext';
import { AuthProvider, useAuthContext } from '@/context/AuthContext';
import { AppRoutes } from './router';
import LoginPage from '@/pages/login/page';

declare const __BASE_PATH__: string;

function AuthGate() {
  const { isAuthenticated, login, error, loading } = useAuthContext();

  if (!isAuthenticated) {
    return <LoginPage onLogin={login} error={error} loading={loading} />;
  }

  return (
    <AppProvider>
      <AppRoutes />
    </AppProvider>
  );
}

export default function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AuthProvider>
        <AuthGate />
      </AuthProvider>
    </BrowserRouter>
  );
}
